<mat-icon>{{icon}}</mat-icon><span>{{ message }}</span>
